import { render, staticRenderFns } from "./InicioWizardEntradaNota.vue?vue&type=template&id=5472cda6"
import script from "./InicioWizardEntradaNota.vue?vue&type=script&lang=js"
export * from "./InicioWizardEntradaNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports